import { render } from "./ProductImageWrapper.vue?vue&type=template&id=5a096356"
import script from "./ProductImageWrapper.vue?vue&type=script&lang=js"
export * from "./ProductImageWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__